import { Component, Input } from '@angular/core';
import { FaqCard } from 'src/app/model/card/faq-card';

@Component({
  selector: 'app-faq-card',
  templateUrl: './faq-card.component.html',
  styleUrls: ['./faq-card.component.scss']
})
export class FaqCardComponent {
  @Input() faqCards: FaqCard[] = [];
  constructor() {}
}
